import './Subiecte.css';

export default function Subiecte2017() {
    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">{'<'}Subiecte 2017{'/>'}</h2>
            <div className="mb-4">
                <h5>1. <strong>August</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2017/SubiectAugust2017MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2017/SubiectAugust2017MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2017/BaremAugust2017MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2017/SubiectAugust2017SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2017/SubiectAugust2017SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2017/BaremAugust2017SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>2. <strong>Iunie</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2017/SubiectIunie2017MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2017/SubiectIunie2017MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2017/BaremIunie2017MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Matematică-Informatică (Rezervă):</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2017/SubiectRezerva2017MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>
                            </li>
                            <li>
                                <a href="/subiecte/2017/BaremRezerva2017MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2017/SubiectIunie2017SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2017/SubiectIunie2017SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2017/BaremIunie2017SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>3. <strong>Sesiunea Specială</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2017/SubiectSpeciala2017MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2017/SubiectSpeciala2017MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2017/BaremSpeciala2017MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2017/SubiectSpeciala2017SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>
                            </li>
                            <li>
                                <a href="/subiecte/2017/BaremSpeciala2017SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>4. <strong>Simulare</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2017/SubiectSimulare2017MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2017/SubiectSimulare2017MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2017/BaremSimulare2017MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2017/SubiectSimulare2017SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2017/SubiectSimulare2017SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2017/BaremSimulare2017SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>5. <strong>Model</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2017/SubiectModel2017MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2017/SubiectModel2017MIPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2017/BaremModel2017MI.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2017/SubiectModel2017SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a> | <a href="/subiecte/2017/SubiectModel2017SNPascal.pdf" target="_blank" rel="noreferrer" className="ms-1">Subiect Pascal</a>
                            </li>
                            <li>
                                <a href="/subiecte/2017/BaremModel2017SN.pdf" target="_blank" rel="noreferrer">Barem</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
}